// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"864ea65d","390":"d1f3e0d2","608":"c919af9c","728":"9f125591","740":"688b7127","878":"a237e5e0","894":"2b591f44","895":"5334d86c","984":"3bc39847"}[chunkId] + ".chunk.js";
};